import {
  faBorderAll,
  faArrowRightArrowLeft,
  faBuildingColumns,
  faCircleCheck,
  faCreditCard,
  faEllipsis,
  faFileInvoice,
  faFolderOpen,
  faGrip,
  faMoneyBillTransfer,
  faReceipt,
  faWandMagicSparkles,
  faUsers,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";

const ICON_PATHS = {
  account: "/Images/account-icon.svg",
  accountSummary: "/Images/Vector.svg",
  administration: "/Images/administration.svg",
  cards: "/Images/sidebar-card.svg",
  pendingApprovals: "/Images/Pending.svg",
  paymentMethods: "/Images/send.svg",
  cashPayment: "/Images/cash-icon.svg",
  expensesBills: "/Images/cash-icon.svg",
  settings: "/Images/settings.svg",
};

const rules = [
  { match: ["overview", "account", "business"], icon: faGrip },
  { match: ["payment", "transfer", "transaction", "exchange"], icon: faArrowRightArrowLeft },
  { match: ["payroll", "salary", "employee"], icon: faUsers },
  { match: ["card"], icon: faCreditCard },
  { match: ["cash", "eod"], icon: faWallet },
  { match: ["report", "statement"], icon: faFileInvoice },
  { match: ["bill"], icon: faReceipt },
  { match: ["bank", "bsl", "iban"], icon: faBuildingColumns },
  { match: ["ai", "assistant"], icon: faWandMagicSparkles },
  { match: ["more", "settings", "merchant", "branch"], icon: faEllipsis },
];

export function getSidebarIcon(value) {
  const text = String(value || "").toLowerCase();
  if (text === "accounts summary") {
    return {
      name: "account-summary",
      type: "image",
      src: ICON_PATHS.accountSummary,
      fallback: faBorderAll,
    };
  }

  if (text === "accounts") {
    return {
      name: "accounts",
      type: "image",
      src: ICON_PATHS.account,
      fallback: faGrip,
    };
  }

  if (text === "cards") {
    return {
      name: "cards",
      type: "image",
      src: ICON_PATHS.cards,
      fallback: faCreditCard,
    };
  }

  if (text === "expenses & bills" || text === "expenses and bills") {
    return {
      name: "expenses-bills",
      type: "image",
      src: ICON_PATHS.expensesBills,
      fallback: faReceipt,
    };
  }

  if (text === "administration") {
    return {
      name: "administration",
      type: "image",
      src: ICON_PATHS.administration,
      fallback: faFolderOpen,
    };
  }

  if (text === "pending approvals") {
    return {
      name: "pending-approvals",
      type: "image",
      src: ICON_PATHS.pendingApprovals,
      fallback: faCircleCheck,
    };
  }

  if (text === "make payment") {
    return {
      name: "make-payment",
      type: "fontawesome",
      icon: faMoneyBillTransfer,
    };
  }

  if (text === "payment methods") {
    return {
      name: "payment-methods",
      type: "image",
      src: ICON_PATHS.paymentMethods,
      fallback: faArrowRightArrowLeft,
    };
  }

  if (text === "cash") {
    return {
      name: "cash-payment",
      type: "image",
      src: ICON_PATHS.cashPayment,
      fallback: faWallet,
    };
  }

  if (text === "settings") {
    return {
      name: "settings",
      type: "image",
      src: ICON_PATHS.settings,
      fallback: faEllipsis,
    };
  }

  return {
    name: "default",
    type: "fontawesome",
    icon:
      rules.find((rule) => rule.match.some((word) => text.includes(word)))?.icon ||
      faFolderOpen,
  };
}

export function getMoreIcon() {
  return faEllipsis;
}

export function getTransactionIcon() {
  return faMoneyBillTransfer;
}
